import Navbar from "../../components/Navbar2";
import Footer from "../../components/Footer2";

const PageLayout = ({ children }: any) => {
  return (
    <div className="min-h-screen font-abel">
      <Navbar title="Login" link="/login" />
      <div className="max-w-[1300px] mx-auto px-3 sm:px-3 lg:px-3">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default PageLayout;
